import { useIntl } from 'react-intl';

interface FieldTranslations {
  label: string;
  placeholder: string;
}
export const useFieldTranslations = (fieldName: string): FieldTranslations => {
  const intl = useIntl();

  return {
    label: intl.formatMessage({ id: `fields.${fieldName}.label` }),
    placeholder: intl.formatMessage({ id: `fields.${fieldName}.placeholder` }),
  };
};
